export function createItemToggleHandler(item: HTMLElement): () => void {
	const copy = item.querySelector('.copy')
	if (!copy) return noop

	const cl = item.classList

	return () => {
		if (cl.contains('active')) {
			cl.remove('active')
			cl.add('inactive')
		} else {
			cl.remove('active')
			cl.add('inactive')
			copy.setAttribute('style', `--height: ${copy.scrollHeight}px;`)
			cl.add('active')
			cl.remove('inactive')
		}
	}
}

function noop() {}
